import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";

import { ColumnData } from "../atoms/fieldGroupAtoms";

//This will allow us to identify python calculated columns
export function useEnrichColumnWithPythonScript() {
  const categoryList = useSelector((state: RootState) => state.groupBy.categoryList);
  const facilityFields = useSelector((state: RootState) => state.groupBy.facilityFields);

  const pythonScriptMap = useMemo(() => {
    const map = new Map<string, string>();

    categoryList.forEach((category) => {
      category.columns?.forEach((col) => {
        if (col.pythonScript) {
          map.set(col.property, col.pythonScript);
        }
      });
    });

    facilityFields.forEach((category) => {
      category.columns?.forEach((col) => {
        if (col.pythonScript) {
          map.set(col.property, col.pythonScript);
        }
      });
    });

    return map;
  }, [categoryList, facilityFields]);

  const enrichColumns = useCallback(
    (columns: ColumnData[]): ColumnData[] => {
      return columns.map((col) => {
        const pythonScript = pythonScriptMap.get(col.propertyName);
        return {
          ...col,
          pythonScript: pythonScript || undefined
        };
      });
    },
    [pythonScriptMap]
  );

  return { enrichColumns };
}
